import { MessageSquareText } from 'lucide-react'

import styles from '../ConversationsPage.module.css'

export function ConversationEmptyState({
  title,
  description,
}: {
  title: string
  description: string
}) {
  return (
    <div className={styles.emptyState} role="status">
      <MessageSquareText size={28} aria-hidden="true" />
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  )
}
